import { useState } from 'react'

import noop from 'lodash/noop'
import useBaseTheme from './useBaseTheme'

const useExternalLinkPopup = (options = {}) => {
  const { websitePopupMessage } = useBaseTheme()
  const [externalLinkModalUrl, setExternalLinkModalUrl] = useState(false)
  const { onBeforeShowModal = noop } = options

  const openUrlInNewWindow = url => {
    const newWindow = window.open()
    newWindow.opener = null
    newWindow.location = url
  }

  const handleLinkoutUrl = ({ url, isExternalUrl }) => {
    if (isExternalUrl && websitePopupMessage) {
      onBeforeShowModal()
      setExternalLinkModalUrl(url)

      return
    }

    openUrlInNewWindow(url)
  }

  return {
    externalLinkModalUrl,
    setExternalLinkModalUrl,
    handleLinkoutUrl,
  }
}

export default useExternalLinkPopup
